import {useParams} from "react-router-dom";
import {FormPage} from "../FormPage/FormPage";
import {ListPageV2} from "./ListPageV2";
import {FormPageV2} from "../FormPage/FormPageV2";

export const CrudPageV2 = () => {

  const { operation} = useParams();

  if (operation === 'form') {
    return <FormPageV2/>
  }

  return <ListPageV2/>

}
